import { DoneAll  } from "@mui/icons-material";
import { Typography } from "@mui/material";

export default function EmptyCart(){

    return (

        <div className="apply-cart-empty">

            <DoneAll />

            <Typography>Votre inscription a été validée</Typography>

        </div>
    );
}